// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
._material-design-icon_1ndue_12 {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
._assistantIcon_1ndue_20 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
._assistantIcon_1ndue_20:not(._assistantIcon_inline_1ndue_25) {
  display: flex;
  min-height: var(--default-clickable-area);
  min-width: var(--default-clickable-area);
}
._assistantIcon__svg_1ndue_30 {
  display: inline-block;
  width: var(--a843d9d2);
  height: var(--a843d9d2);
  max-width: var(--a843d9d2);
  max-height: var(--a843d9d2);
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcAssistantIcon-BoOnqVRr.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,yCAAyC;EACzC,wCAAwC;AAC1C;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;AAC7B","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n._material-design-icon_1ndue_12 {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n._assistantIcon_1ndue_20 {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n._assistantIcon_1ndue_20:not(._assistantIcon_inline_1ndue_25) {\n  display: flex;\n  min-height: var(--default-clickable-area);\n  min-width: var(--default-clickable-area);\n}\n._assistantIcon__svg_1ndue_30 {\n  display: inline-block;\n  width: var(--a843d9d2);\n  height: var(--a843d9d2);\n  max-width: var(--a843d9d2);\n  max-height: var(--a843d9d2);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
